export const actionTypes = {
  NOTIFICATION_LIST_REQUEST: 'NOTIFICATION_LIST_REQUEST',
  NOTIFICATION_LIST_SUCCESS: 'NOTIFICATION_LIST_SUCCESS',
  TOP_NOTIFICATION_LIST_SUCCESS: 'TOP_NOTIFICATION_LIST_SUCCESS',
  NOTIFICATION_LIST_FAILURE: 'NOTIFICATION_LIST_FAILURE',
  UPDATE_NOTIFICATION_STATUS_SUCCESS: 'UPDATE_NOTIFICATION_STATUS_SUCCESS',
  UPDATE_NOTIFICATION_STATUS_FAILURE: 'UPDATE_NOTIFICATION_STATUS_FAILURE',
};
